import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CategoryYearbook {
  name: string;
  api_token: string;
}

export interface CategoryYearbookDetaiInfor {
  errors: unknown;
  CategoryYearbook: CategoryYearbook;
  isAuthenticated: boolean;
}

@Module
export default class CategoryYearbookDetail
  extends VuexModule
  implements CategoryYearbookDetaiInfor
{
  errors = {};
  CategoryYearbook = {} as CategoryYearbook;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get CategoryYearbookDetail() {
    return this.categoryYearbookDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.CATEGORY_YEARBOOK_DETAIL_DATA](CategoryYearbook) {
    this.categoryYearbookDetailData = CategoryYearbook;
  }
  @Action
  [Actions.CATEGORY_YEARBOOK_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/dm_chitieu_niengiam",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(Mutations.CATEGORY_YEARBOOK_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
